import { render, staticRenderFns } from "./AppDrawer.vue?vue&type=template&id=2fc467aa&"
import script from "./AppDrawer.vue?vue&type=script&lang=ts&"
export * from "./AppDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./AppDrawer.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports